import React from 'react';
import DesktopHeaderSearch from './DesktopHeaderSearch';
import MobileSignedOutHeader from './MobileSignedOutHeader';
import DesktopSignedInHeader from './DesktopSignedInHeader';
import MobileSignedInHeader from './MobileSignedInHeader';

interface HeaderProps {
    setMobileMenuOpen: (open: boolean) => void;
    mobileMenuOpen: boolean;
    isAuthenticated: boolean;
}

const Header: React.FC<HeaderProps> = ({ setMobileMenuOpen, mobileMenuOpen, isAuthenticated = false }) => {
    return (
        <>
            <div id="mobile-header" className="lg:hidden">
                {
                    isAuthenticated ? (
                        <>
                            <MobileSignedInHeader setMobileMenuOpen={setMobileMenuOpen} mobileMenuOpen={mobileMenuOpen} />
                        </>
                    ) : (
                        <>
                            <MobileSignedOutHeader setMobileMenuOpen={setMobileMenuOpen} mobileMenuOpen={mobileMenuOpen} />
                        </>
                    )
                }
            </div>
        </>
    );
};

export default Header;
